<template>
  <div class="turbo-positions">
    <!-- Tabs -->
    <div class="tabs">
      <button
        v-for="tab in tabs"
        :key="tab"
        :class="['tab-btn', { active: currentTab === tab }]"
        @click="currentTab = tab"
      >
        {{ tab }}
      </button>
    </div>

    <!-- ✅ Active Trades -->
    <div v-if="currentTab === 'Active'" class="table-container">
      <!-- PC (Tablo) -->
      <table class="positions-table desktop-only">
        <thead>
          <tr>
           <th>{{ $t('turbo.symbol') }}</th>
<th>{{ $t('turbo.side') }}</th>
<th>{{ $t('turbo.amount') }}</th>
<th>{{ $t('turbo.entry') }}</th>
<th>{{ $t('turbo.duration') }}</th>
<th>{{ $t('turbo.countdown') }}</th>

          </tr>
        </thead>
        <tbody>
          <tr v-for="trade in activeTrades" :key="trade._id" class="trade-row">
            <td>
              <img :src="coinIcon(trade.symbol)" class="coin-icon" />
              {{ trade.symbol }}
            </td>
            <td>
              <span class="side-badge" :class="trade.direction.toLowerCase()">
                <img
                  v-if="trade.direction === 'UP'"
                  src="@/assets/img/trade/up.svg"
                  class="side-icon"
                />
                <img
                  v-else
                  src="@/assets/img/trade/down.svg"
                  class="side-icon"
                />
                {{ trade.direction }}
              </span>
            </td>
            <td>{{ getFiatSymbol(trade) }}{{ formatCurrency(trade.amount) }}</td>
            <td>${{ formatPrice(trade.entryPrice) }}</td>
            <td>{{ trade.duration }}s</td>
            <td>
              <div class="progress-container">
                <div
                  class="progress-bar"
                  :style="{ width: progressPercent(trade) + '%' }"
                ></div>
                <span class="countdown">{{ remainingSeconds(trade) }}s</span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <!-- Mobil (Kartlar) -->
      <div class="mobile-only">
        <div class="mobile-header active">
          <span> {{ $t('turbo.Position') }}</span>
          <span> {{ $t('turbo.Amount') }}</span>
          <span> {{ $t('turbo.Countdown') }}</span>
        </div>
        <div
          v-for="trade in activeTrades"
          :key="trade._id"
          class="trade-card"
        >
          <div class="trade-header">
            <!-- Position -->
            <div class="position-badge">
              <img :src="coinIcon(trade.symbol)" class="coin-icon" />
              <img
                v-if="trade.direction === 'UP'"
                src="@/assets/img/trade/up.svg"
                class="side-icon"
              />
              <img
                v-else
                src="@/assets/img/trade/down.svg"
                class="side-icon"
              />
            </div>
            <!-- Amount -->
            <div class="amount">
              {{ getFiatSymbol(trade) }}{{ formatCurrency(trade.amount) }}
            </div>
            <!-- Countdown -->
            <div class="progress-container">
              <div
                class="progress-bar"
                :style="{ width: progressPercent(trade) + '%' }"
              ></div>
              <span class="countdown">{{ remainingSeconds(trade) }}s</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ✅ Closed Trades -->
    <div v-if="currentTab === 'Closed'" class="table-container">
      <!-- PC (Tablo) -->
      <table class="positions-table desktop-only">
        <thead>
          <tr>
            <th> {{ $t('turbo.Symbol') }}</th>
            <th> {{ $t('turbo.Side') }}</th>
            <th> {{ $t('turbo.Amount') }}</th>
            <th> {{ $t('turbo.entry') }}</th>
            <th>{{ $t('turbo.Close') }}</th>
            <th>{{ $t('turbo.Payout') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="trade in paginatedClosedTrades"
            :key="trade._id"
            class="trade-row"
          >
            <td><img :src="coinIcon(trade.symbol)" class="coin-icon" /> {{ trade.symbol }}</td>
            <td>
              <span class="side-badge" :class="trade.direction.toLowerCase()">
                <img
                  v-if="trade.direction === 'UP'"
                  src="@/assets/img/trade/up.svg"
                  class="side-icon"
                />
                <img
                  v-else
                  src="@/assets/img/trade/down.svg"
                  class="side-icon"
                />
                {{ trade.direction }}
              </span>
            </td>
            <td>{{ getFiatSymbol(trade) }}{{ formatCurrency(trade.amount) }}</td>
            <td>${{ formatPrice(trade.entryPrice) }}</td>
            <td>${{ formatPrice(trade.closePrice) }}</td>
            <td>
              <span v-if="trade.result === 'win'" class="payout-badge win">
                +{{ getFiatSymbol(trade) }}{{ formatCurrency(trade.payoutAmount) }}
              </span>
              <span v-else class="payout-badge lose">
                -{{ getFiatSymbol(trade) }}{{ formatCurrency(trade.amount) }}
              </span>
            </td>
          </tr>
        </tbody>
      </table>

     <!-- ✅ Closed Mobil Header -->
      <div class="mobile-only">
<div class="mobile-header closed">
  <span> {{ $t('turbo.Position') }}</span>
  <span> {{ $t('turbo.Amount') }}</span>
  <span> {{ $t('turbo.Payout') }}</span>
  <span> {{ $t('turbo.Info') }}</span>
</div>

<div
  v-for="trade in paginatedClosedTrades"
  :key="trade._id"
  class="trade-card"
>
  <div class="trade-header">
    <!-- Position -->
    <div class="position-badge">
      <img :src="coinIcon(trade.symbol)" class="coin-icon" />
      <img
        v-if="trade.direction === 'UP'"
        src="@/assets/img/trade/up.svg"
        class="side-icon"
      />
      <img
        v-else
        src="@/assets/img/trade/down.svg"
        class="side-icon"
      />
    </div>
    <!-- Amount -->
    <div class="amount">
      {{ getFiatSymbol(trade) }}{{ formatCurrency(trade.amount) }}
    </div>
    <!-- Payout -->
    <div>
      <span v-if="trade.result === 'win'" class="payout-badge win">
        +{{ getFiatSymbol(trade) }}{{ formatCurrency(trade.payoutAmount) }}
      </span>
      <span v-else class="payout-badge lose">
        -{{ getFiatSymbol(trade) }}{{ formatCurrency(trade.amount) }}
      </span>
    </div>
    <!-- Info -->
    <div class="info-btn" @click="openDetails(trade)">ℹ️</div>
  </div>
</div>

      <!-- Pagination -->
      <div class="pagination desktop-only">
        <button :disabled="closedPage === 1" @click="closedPage--"> {{ $t('turbo.Prev') }}</button>
        <span> {{ $t('turbo.Page') }} {{ closedPage }} / {{ closedTotalPages }}</span>
        <button :disabled="closedPage === closedTotalPages" @click="closedPage++"> {{ $t('turbo.Next') }}</button>
      </div>
    </div>
</div>
    <!-- ✅ Public Trades -->
    <div v-if="currentTab === 'Public'" class="table-container">
      <!-- PC (Tablo) -->
      <table class="positions-table desktop-only">
        <thead>
          <tr>
            <th> {{ $t('turbo.User') }}</th>
            <th> {{ $t('turbo.Symbol') }}</th>
            <th> {{ $t('turbo.Side') }}</th>
            <th> {{ $t('turbo.Amount') }}</th>
            <th> {{ $t('turbo.Result') }}</th>
            <th> {{ $t('turbo.Payout') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="trade in limitedPublicTrades" :key="trade._id" class="trade-row">
            <td class="user-cell">
              <div class="user-info">
                <img
                  v-if="trade.user?.avatar"
                  :src="trade.user.avatar.startsWith('http')
                        ? trade.user.avatar
                        : process.env.VUE_APP_BACKEND_URL + trade.user.avatar"
                  class="avatar-image"
                  alt="avatar"
                />
                <span class="username">{{ trade.user?.username || "Anon" }}</span>
                <img
                  v-if="vipBadgeImage"
                  :src="vipBadgeImage"
                  class="vip-badge-small"
                  alt="VIP"
                />
              </div>
            </td>
            <td><img :src="coinIcon(trade.symbol)" class="coin-icon" /> {{ trade.symbol }}</td>
            <td>
              <span class="side-badge" :class="trade.direction.toLowerCase()">
                <img
                  v-if="trade.direction === 'UP'"
                  src="@/assets/img/trade/up.svg"
                  class="side-icon"
                />
                <img
                  v-else
                  src="@/assets/img/trade/down.svg"
                  class="side-icon"
                />
                {{ trade.direction }}
              </span>
            </td>
            <td>{{ getFiatSymbol(trade) }}{{ formatCurrency(trade.amount) }}</td>
            <td :class="trade.result">
              {{ trade.result?.toUpperCase() || "PENDING" }}
            </td>
            <td>
              <span v-if="trade.result === 'win'" class="payout-badge win">
                +{{ getFiatSymbol(trade) }}{{ formatCurrency(trade.payoutAmount) }}
              </span>
              <span v-else-if="trade.result === 'lose'" class="payout-badge lose">
                -{{ getFiatSymbol(trade) }}{{ formatCurrency(trade.amount) }}
              </span>
              <span v-else class="payout-badge pending"> {{ $t('turbo.PENDING') }}</span>
            </td>
          </tr>
        </tbody>
      </table>

<!-- ✅ Public Mobil Header -->
<div class="mobile-only">
<div class="mobile-header public">
  <span> {{ $t('turbo.User') }}</span>
  <span> {{ $t('turbo.Position') }}</span>
  <span> {{ $t('turbo.Amount') }}</span>
  <span> {{ $t('turbo.Payout') }}</span>
  <span> {{ $t('turbo.Info') }}</span>
</div>

<div
  v-for="trade in limitedPublicTrades"
  :key="trade._id"
  class="trade-card"
>
  <div class="trade-header">
    <!-- User (avatar only) -->
    <div class="position-badge">
      <img
        v-if="trade.user?.avatar"
        :src="trade.user.avatar.startsWith('http')
              ? trade.user.avatar
              : process.env.VUE_APP_BACKEND_URL + trade.user.avatar"
        class="avatar-image"
        alt="avatar"
      />
    </div>

    <!-- Position (coin + up/down) -->
    <div class="position-badge">
      <img :src="coinIcon(trade.symbol)" class="coin-icon" />
      <img
        v-if="trade.direction === 'UP'"
        src="@/assets/img/trade/up.svg"
        class="side-icon"
        alt="UP"
      />
      <img
        v-else
        src="@/assets/img/trade/down.svg"
        class="side-icon"
        alt="DOWN"
      />
    </div>

    <!-- Amount -->
    <div class="amount">
      {{ getFiatSymbol(trade) }}{{ formatCurrency(trade.amount) }}
    </div>

    <!-- Payout -->
    <div>
      <span v-if="trade.result === 'win'" class="payout-badge win">
        +{{ getFiatSymbol(trade) }}{{ formatCurrency(trade.payoutAmount) }}
      </span>
      <span v-else-if="trade.result === 'lose'" class="payout-badge lose">
        -{{ getFiatSymbol(trade) }}{{ formatCurrency(trade.amount) }}
      </span>
      <span v-else class="payout-badge pending"> {{ $t('turbo.PENDING') }}</span>
    </div>

    <!-- Info -->
    <div class="info-btn" @click="openDetails(trade)">ℹ️</div>
  </div>
  </div>
</div>
    </div>
 <!-- Trade Details Bottom Sheet -->
<div v-if="showDetails" class="bottom-sheet">
  <div class="bottom-sheet-header">
    <h3> {{ $t('turbo.Trade Details') }}</h3>
    <button class="btn-close-modal" @click="closeDetails">×</button>
  </div>

  <div class="bottom-sheet-content">
    <!-- User Info -->
    <div class="user-section">
      <img
        v-if="selectedTrade.user?.avatar"
        :src="selectedTrade.user.avatar.startsWith('http')
          ? selectedTrade.user.avatar
          : process.env.VUE_APP_BACKEND_URL + selectedTrade.user.avatar"
        class="avatar-large"
        alt="avatar"
      />
      <div class="user-meta">
        <span class="username">{{ selectedTrade.user?.username || "Anon" }}</span>
        <img
          v-if="selectedTrade.user?.vipBadgeImage"
          :src="process.env.VUE_APP_BACKEND_URL + selectedTrade.user.vipBadgeImage"
          class="vip-badge"
          alt="VIP"
        />
      </div>
    </div>

    <!-- Position -->
    <div class="position-section">
      <div class="coin-badge">
        <img :src="coinIcon(selectedTrade.symbol)" class="coin-icon" />
        <img
          v-if="selectedTrade.direction === 'UP'"
          src="@/assets/img/trade/up.svg"
          class="side-icon"
        />
        <img
          v-else
          src="@/assets/img/trade/down.svg"
          class="side-icon"
        />
      </div>
      <div class="amount">
        {{ getFiatSymbol(selectedTrade) }}{{ formatCurrency(selectedTrade.amount) }}
      </div>
    </div>

    <!-- Trade Info -->
    <div class="details-grid">
      <div class="detail-box">
        <span> {{ $t('turbo.Entry Price') }}</span>
        <b>${{ formatPrice(selectedTrade.entryPrice) }}</b>
      </div>
      <div class="detail-box">
        <span> {{ $t('turbo.Close Price') }}</span>
        <b v-if="selectedTrade.closePrice">${{ formatPrice(selectedTrade.closePrice) }}</b>
        <b v-else>-</b>
      </div>
      <div class="detail-box">
        <span> {{ $t('turbo.Duration') }}</span>
        <b>{{ selectedTrade.duration }}s</b>
      </div>
      <div class="detail-box">
        <span> {{ $t('turbo.Result') }}</span>
        <b :class="selectedTrade.result">{{ selectedTrade.result?.toUpperCase() || "PENDING" }}</b>
      </div>
      <div class="detail-box payout-box">
        <span> {{ $t('turbo.Payout') }}</span>
        <b v-if="selectedTrade.result === 'win'" class="payout-badge win">
          +{{ getFiatSymbol(selectedTrade) }}{{ formatCurrency(selectedTrade.payoutAmount) }}
        </b>
        <b v-else-if="selectedTrade.result === 'lose'" class="payout-badge lose">
          -{{ getFiatSymbol(selectedTrade) }}{{ formatCurrency(selectedTrade.amount) }}
        </b>
        <b v-else class="payout-badge pending"> {{ $t('turbo.PENDING') }}</b>
      </div>
      <div class="detail-box">
        <span> {{ $t('turbo.Created At') }}</span>
        <b>{{ new Date(selectedTrade.createdAt).toLocaleString() }}</b>
      </div>
    </div>
  </div>

  <div class="bottom-sheet-footer">
    <button class="btn-close-modal" @click="closeDetails"> {{ $t('turbo.Close') }}</button>
  </div>
</div>

  </div>
</template>



<script setup>
import { ref, computed, onMounted, onBeforeUnmount } from "vue"
import { useStore } from "vuex"

const store = useStore()
const tabs = ["Active", "Closed", "Public"]
const currentTab = ref("Active")

const trades = ref([])        // kendi trades’im
const publicTrades = ref([])  // tüm kullanıcıların trades’i
const tick = ref(Date.now())
let timer = null

const showInfo = ref(false)
const selectedTrade = ref(null)
const showDetails = ref(false)

function openDetails(trade) {
  selectedTrade.value = trade
  showDetails.value = true
}

function closeDetails() {
  selectedTrade.value = null
  showDetails.value = false
}
/* -------------------
   Vuex Getters & Actions
------------------- */
const authUser = computed(() => store.getters.authUser)
const vipLevel = computed(() => store.getters["vip/vipLevel"])
const userXp = computed(() => store.getters["vip/userXp"])

const xpProgress = computed(() => {
  return vipLevel.value?.requiredXp
    ? Math.min((userXp.value / vipLevel.value.requiredXp) * 100, 100).toFixed(2)
    : 0
})

const vipBadgeImage = computed(() => {
  return vipLevel.value?.vipBadgeImage
    ? process.env.VUE_APP_BACKEND_URL + vipLevel.value.vipBadgeImage
    : null
})

function fetchUserVip() {
  store.dispatch("vip/fetchUserVip")
}

/* -------------------
   Socket ile fetch
------------------- */
function fetchMyTrades() {
  const socket = store.getters.socketGeneral
  socket.emit("turbo:list", { token: store.getters.authToken }, (res) => {
    if (res.success) trades.value = res.trades
  })
}

function fetchPublicTrades() {
  const socket = store.getters.socketGeneral
  socket.emit("turbo:public:list", (res) => {
    if (res.success) {
      // sadece sonuçlananları yükle
      publicTrades.value = res.trades.filter(
        (t) => t.result === "win" || t.result === "lose"
      )
    }
  })
}


/* -------------------
   Pagination
------------------- */
const closedPage = ref(1)
const pageSize = 10

const closedTotalPages = computed(() =>
  Math.ceil(closedTrades.value.length / pageSize)
)

const paginatedClosedTrades = computed(() => {
  const start = (closedPage.value - 1) * pageSize
  return closedTrades.value.slice(start, start + pageSize)
})

/* -------------------
   Public limit
------------------- */
const limitedPublicTrades = computed(() =>
  publicTrades.value.slice(0, 10)
)

/* -------------------
   Trade grupları
------------------- */
const activeTrades = computed(() =>
  trades.value.filter((t) => t.status === "open")
)
const closedTrades = computed(() =>
  trades.value.filter((t) => t.status === "closed")
)

/* -------------------
   Countdown & Progress
------------------- */
function remainingSeconds(trade) {
  tick.value
  const now = Date.now()
  const end = new Date(trade.endTime).getTime()
  return Math.max(0, Math.floor((end - now) / 1000))
}

function progressPercent(trade) {
  tick.value
  const start = new Date(trade.startTime).getTime()
  const end = new Date(trade.endTime).getTime()
  const now = Date.now()
  const total = end - start
  const left = Math.max(0, end - now)
  return ((total - left) / total) * 100
}

/* -------------------
   Formatters
------------------- */
const fiatMap = {
  TRY: "₺",
  USD: "$",
  EUR: "€",
  USDT: "₮",
  CNY: "¥",
  INR: "₹",
  IDR: "Rp",
}

function getFiatSymbol(trade) {
  return fiatMap[trade.fiatCurrency] || trade.fiatCurrency
}

function formatCurrency(v) {
  return v != null ? Number(v).toFixed(2) : "-"
}
function formatPrice(v) {
  return v != null ? Number(v).toFixed(5) : "-"
}

function coinIcon(symbol) {
  const base = symbol.replace(/USDT|BUSD|USD|TRY|EUR|USDC$/i, "")
  return `https://cdn.jsdelivr.net/gh/vadimmalykhin/binance-icons/crypto/${base.toLowerCase()}.svg`
}

/* -------------------
   Lifecycle
------------------- */
onMounted(() => {
  fetchUserVip()
  fetchMyTrades()
  fetchPublicTrades()

  // timer başlat
  timer = setInterval(() => {
    tick.value = Date.now()
  }, 1000)

  const socket = store.getters.socketGeneral

  // ✅ benim trades’im
  socket.on("turbo:trade", (data) => {
    const idx = trades.value.findIndex((t) => t._id === data.trade._id)
    if (idx === -1) trades.value.unshift(data.trade)
    else trades.value[idx] = data.trade
  })


socket.on("turbo:public", (data) => {
  const trade = data.trade

  // sadece sonuçlanan trades (win/lose)
  if (trade?.result === "win" || trade?.result === "lose") {
    // en başa ekle
    publicTrades.value.unshift(trade)

    // 50 kayıttan fazla olmasın
    if (publicTrades.value.length > 50) {
      publicTrades.value.pop()
    }
  }
})

})


onBeforeUnmount(() => {
  clearInterval(timer)
  const socket = store.getters.socketGeneral
  socket.off("turbo:trade")
  socket.off("turbo:public")
})

</script>






<style scoped>
.turbo-positions {
  background: var(--background3);
  padding: 10px;
  border-radius: 7px;
  margin: 24px 0;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  z-index: 1;
  position: relative;
}
 

.tabs {
  display: flex;
  gap: 12px;
  margin-bottom: 24px;
}

.tab-btn {
  padding: 10px 20px;
  border-radius: 5px;
  background: var(--background2);
  color: #cccccc;
  font-weight: 500;
  transition: all 0.3s ease;
  cursor: pointer;
}

.tab-btn.active {
  background: var(--buttonyellow);
  color: #000;
  box-shadow: rgb(197, 106, 24) 0px -3px 0px 0px inset, rgb(255, 234, 47) 0px 2px 0px 0px inset;
}

.table-container {
  overflow-x: auto;
}

.positions-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0 10px; /* satırlar arasında boşluk */
}

.positions-table th,
.positions-table td {
  padding: 12px 16px;
  text-align: left;
  
  font-size: 14px;
}

.positions-table th {
  
  color: #ffffff;
  font-weight: 600;
  position: sticky;
  top: 0;
}

.positions-table td {
  color: #cccccc;
}

.trade-row {
  background: var(--background2);            /* koyu arka plan */
  
  overflow: hidden;
  border-radius: 8px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.3);
}
.trade-row td:first-child {
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
}

.trade-row td:last-child {
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
}

.trade-row td {
  padding: 12px 16px;
  
}

.long, .up { color: #4caf50; font-weight: bold; }
.down { color: #f44336; font-weight: bold; }
.win { color: #4caf50; font-weight: bold; }
.lose { color: #f44336; font-weight: bold; }

.progress-container {
  position: relative;
  width: 120px;
  height: 14px;
  background: var(--bar-outer);
  border-radius: 6px;
  overflow: hidden;
}

.progress-bar {
  height: 100%;
  background: var(--bar-inner);
  transition: width 1s linear;
}

.countdown {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%); 
  font-size: 11px;
  font-weight: bold;
  color: #000;
}

.coin-icon {
  width: 18px;
  height: 18px;
  margin-right: 6px;
  vertical-align: middle;
}

.side-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: 6px;
  font-weight: 600;
  font-size: 13px;
}

.side-badge.up {
  background: rgba(34, 197, 94, 0.15); /* yeşil transparan */
  color: #22c55e;
}

.side-badge.down {
  background: rgba(239, 68, 68, 0.15); /* kırmızı transparan */
  color: #ef4444;
}

.side-icon {
  width: 14px;
  height: 14px;
}

/* Payout */
.payout {
  font-weight: 700;
  font-size: 14px;
}

.payout.win {
  color: #22c55e; /* yeşil */
}

.payout.lose {
  color: #ef4444; /* kırmızı */
}
.payout-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 4px 10px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 700;
  color: #fff;
  min-width: 80px;
  text-align: center;
}

.payout-badge.win {
  background: rgba(34, 197, 94, 0.15); /* yeşil transparan */
  color: #22c55e;
}

.payout-badge.lose {
 background: rgba(239, 68, 68, 0.15); /* kırmızı transparan */
  color: #ef4444;
}

.user-cell {
  display: flex;
  align-items: center;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 8px;
}

.avatar-box {
  position: relative;
  width: 28px;
  height: 28px;
}

.avatar-image {
  width: 28px;
  height: 28px;
  border-radius: 50%;
}



.vip-badge-small {
  
  width: 17px;
  height: 17px;
}

.username {
  font-weight: 600;
  color: #f3f4f6;
}

.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  margin-top: 16px;
}

.pagination button {
  padding: 6px 12px;
  border-radius: 6px;
  background: #2a2a2a;
  color: #fff;
  border: none;
  cursor: pointer;
}

.pagination button:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
/* PC/Mobil ayırıcı */
/* PC görünüm */
.desktop-only { display: table; }
.mobile-only { display: none; }

/* Mobil görünüm */
@media (max-width: 768px) {
  .desktop-only { display: none; }
  .mobile-only { display: block; }

  /* trade kartları */
  .trade-card {
    background: var(--background2);
    border-radius: 8px;
    padding: 12px;
    margin-bottom: 12px;
    box-shadow: 0 2px 6px rgba(0,0,0,0.3);
  }

  .trade-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
  }

  /* coin + up/down kutusu */
  .position-badge {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 6px 10px;
    border-radius: 6px;
    background: var(--background1);
  }

  .coin-icon {
    width: 20px;
    height: 20px;
  }

  .side-icon {
    width: 18px;
    height: 18px;
  }

  /* miktar */
  .amount {
    font-weight: 600;
    color: #fff;
    font-size: 14px;
  }

  /* info butonu (Closed & Public için) */
  .info-btn {
     cursor: pointer;
  font-size: 14px;
  padding: 4px 6px;
  border-radius: 10px;
 background: rgb(44, 40, 82);
    color: rgb(217, 209, 244);
    box-shadow: rgb(35, 32, 66) 0px -3px 0px 0px inset, rgb(89, 81, 142) 0px 2px 0px 0px inset;
    text-shadow: rgb(25, 25, 57) 0px 1px 0px;
    color: #fff;
    border: 3px solid var(--roo-btn-outline-color, #090C1D);
    font-size: 18px;
    cursor: pointer;
  }

  /* progress bar (Active için) */
  .progress-container {
    position: relative;
   
    height: 12px;
    background: var(--bar-outer);
    border-radius: 6px;
    margin-top: 8px;
    overflow: hidden;
  }

  .progress-bar {
    height: 100%;
    background: var(--bar-inner);
    transition: width 1s linear;
  }

  .countdown {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 10px;
    font-weight: 600;
    color: #000;
  }

  /* avatar sadece public mobile’da */
  .avatar-image {
    width: 28px;
    height: 28px;
    border-radius: 50%;
  }
}

.bottom-sheet {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  background: var(--background);
  border-radius: 16px 16px 0 0;
  padding: 24px;
  max-height: 85vh;
  overflow-y: auto;
  z-index: 1000;
  padding-bottom: 70px;
}

.bottom-sheet-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  color: #fff;
}

.bottom-sheet-content {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* User Info */
.user-section {
  display: flex;
  align-items: center;
  gap: 12px;
}

.avatar-large {
  width: 48px;
  height: 48px;
  border-radius: 50%;
}

.user-meta {
  display: flex;
  align-items: center;
  gap: 8px;
}

.username {
  font-size: 16px;
  font-weight: 600;
  color: #fff;
}

.vip-badge {
  width: 20px;
  height: 20px;
}

/* Position */
.position-section {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: var(--background2);
  padding: 12px 16px;
  border-radius: 8px;
}

.coin-badge {
  display: flex;
  align-items: center;
  gap: 6px;
}

.amount {
  font-size: 16px;
  font-weight: 600;
  color: #fff;
}

/* Details Grid */
.details-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.detail-box {
  background: var(--background2);
  padding: 12px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.detail-box span {
  font-size: 12px;
  color: #aaa;
}

.detail-box b {
  font-size: 14px;
  color: #fff;
  font-weight: 600;
}

.detail-box .win {
  color: #22c55e;
}

.detail-box .lose {
  color: #ef4444;
}

.payout-box b {
  font-size: 15px;
}

/* Footer */
.bottom-sheet-footer {
  margin-top: 16px;
  display: flex;
  justify-content: flex-end;
}

.btn-close-modal {
  background: var(--background2);
  border: none;
  color: #fff;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
}

/* Mobil header */
@media (max-width: 768px) {
  .mobile-header {
    display: grid;
    grid-template-columns: repeat(3, 1fr); /* sütun sayısına göre ayarla */
    font-size: 12px;
    font-weight: 600;
    color: #aaa;
    margin-bottom: 8px;
    padding: 0 4px;
  }

  /* active için 3 kolon: Position, Amount, Countdown */
  .mobile-header.active { grid-template-columns: 1fr 1fr 1fr;  margin-left: 20px; }
  

  /* closed & public için 3 kolon: Position, Amount, Info/Payout */
  /* Closed mobil tablo grid */
.positions-table.closed tr,
.mobile-header.closed {
 grid-template-columns: 1fr 1fr 1.2fr auto;
        margin-left: 15px;
        margin-right: 15px;
}

/* Public mobil tablo grid */
.positions-table.public tr,
.mobile-header.public {
 grid-template-columns: 1fr 1fr 1fr 1fr auto; 
        margin-left: 15px;
        margin-right: 15px;
}
}

</style>
